import AdmissionScreen from "app/screens/residents/show/AdmissionScreen";

export default function ResidentAdmissionPage() {
  return <AdmissionScreen />;
}
